
import { computed, ComputedRef, defineComponent, reactive, Ref, ref } from "vue";
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useI18n } from "vue-i18n";

import { Props, validateInfos } from 'ant-design-vue/lib/form/useForm';
import { message, Form } from 'ant-design-vue';
const useForm = Form.useForm;

import useI18nAntdFormVaildateInfos from '@/composables/useI18nAntdFormVaildateInfos';
import { RegisterParamsType } from "./data.d";
import { StateType as RegisterStateType } from "./store";

import { UserOutlined, UnlockOutlined } from '@ant-design/icons-vue';

import { isEmail, isPassword } from '@/utils/validate'

interface UserRegisterSetupData {
    t: (key: string | number) => string;
    validateInfos: ComputedRef<validateInfos>;
    modelRef: RegisterParamsType;
    submitLoading: Ref<boolean>;
    disabled: Ref<boolean>;
    checked: Ref<boolean>;
    handleSubmit: (e: MouseEvent) => void;
    errorMsg: ComputedRef<string | undefined>;
    handleGoto: (t: string) => void;
}

export default defineComponent({
    name: 'UserRegister',
    components: {
        UserOutlined,
        UnlockOutlined
    },
    setup(): UserRegisterSetupData {
        const router = useRouter();
        const store = useStore<{userregister: RegisterStateType}>();
        const { t } = useI18n();
        const checked = ref<boolean>(false)

        // 表单值
        const modelRef = reactive<RegisterParamsType>({
            email: '',
            password: '',
        });
        // 表单验证
        const rulesRef = reactive({
            email: [
                {
                    // required: true,
                    // trigger: 'blur',
                    validator: (rule: any, value: string, callback: any)=>{
                        // const exp= /^([a-z]+[a-zA-Z0-9\.\_]*)\@(qq|vip.qq|foxmail)+\.(com)$/
                        if(isEmail(value)){
                            return Promise.resolve()
                        }else{
                            return Promise.reject(t('page.user.register.form-item-username.required'))
                        }
                    }
                },
            ],
            password: [
                {
                    required: true,
                    validator: (rule: any, value: string, callback: any)=>{
                        if(value == ''){
                            return Promise.reject('请输入密码')
                        }else if(!isPassword(value)){
                            return Promise.reject('密码为6-20位大小写字母、数字或符号的至少两种组合')
                        }else{
                            return Promise.resolve()
                        }
                    }
                },
            ],
        });
        // 获取表单内容
        const { validate, validateInfos } = useForm(modelRef, rulesRef);
        // 注册loading
        const submitLoading = ref<boolean>(false);
        // 注册
        const handleSubmit = async (e: MouseEvent) => {
            e.preventDefault()
            submitLoading.value = true;
            try {
                const fieldsValue = await validate<RegisterParamsType>();
                const res: boolean = await store.dispatch('userregister/register',fieldsValue);
                const email = modelRef.email;
                if (res === true) {
                    // message.success(t('page.user.register.form.register-success'));
                    localStorage.setItem('regEmail',email);
                    router.replace('/user/activation');
                }
            } catch (error) {
                // console.log('error', error);
                message.warning(t('app.global.form.validatefields.catch'));
            }
            submitLoading.value = false;

        };

        // 重置 validateInfos
        const validateInfosNew = useI18nAntdFormVaildateInfos(validateInfos);

         // 注册状态
        const errorMsg = computed<string | undefined>(()=> store.state.userregister.errorMsg);

        const disabled = computed<boolean>(()=>{
            return !(modelRef.email && modelRef.password && checked.value)
        })

        const handleGoto = (t: string) => {
            let url:any = null
            if(t === 'agre'){
                url = router.resolve({
                    path: '/agreetdesc',
                    query: {type: 'agre'}
                })
            }else{
                url = router.resolve({
                    path: '/agreetdesc',
                    query: {type: 'desc'}
                })
            }
            window.open(url.href, '_blank')
        }

        return {
            t,
            modelRef,
            validateInfos: validateInfosNew,
            submitLoading,
            handleSubmit,
            errorMsg,
            disabled,
            checked,
            handleGoto
        }

    }
})
